import { ICollaboratorsData, IExternalFileResponse, IMembersData } from '../interfaces/businessData';
import {
  ICollaboratorDataRF,
  ICollaboratorDependents,
  ICollaboratorInsuranceDetail,
  IMemberFRCardBalances,
  IMemberFRCycleConsumptions,
  IUnsubscribedCollaboratorsData,
  IUnsubscribedMembersData
} from '../interfaces/collaborators';
import { IMemberByFileData, IValidateDependentsFileResponse } from '../interfaces/manageCollaborators';

const requesterEmail = 'admin@empresa.com';
const companyName = 'Mock Company A';
const agreementName = 'US/US-EMP-EMP-01/8.50';
const agreementName2 = 'US/US-EMP-EMP-02/9.00';
const agreementName3 = 'CL/CL-ABO-ABO-01/9.99';

const gender = 'collaborators_datatable-column_gender_female';
const genderMale = 'collaborators_datatable-column_gender_male';
const generation = 'collaborators_datatable-column_generation_millennial';
const mockInProgress = 'in_progress';

export const COLLABORATORS_MOCK_DATA: ICollaboratorsData[] = [
  {
    fullName: 'Smith, John',
    documentValue: '21-A',
    gender: genderMale,
    generation: generation,
    joinedAt: '15/06/2015',
    agreementName: agreementName,
    id: '101',
    isActive: true,
    sendEmail: false
  },
  {
    fullName: 'Johnson, Emily',
    documentValue: '22-B',
    gender: gender,
    generation: generation,
    joinedAt: '22/08/2016',
    agreementName: agreementName,
    id: '102',
    isActive: false,
    sendEmail: true
  },
  {
    fullName: 'Williams, Michael',
    documentValue: '23-C',
    gender: genderMale,
    generation: generation,
    joinedAt: '10/03/2017',
    agreementName: agreementName,
    id: '103',
    isActive: true,
    sendEmail: true
  },
  {
    fullName: 'Brown, Jessica',
    documentValue: '24-D',
    gender: gender,
    generation: generation,
    joinedAt: '05/11/2017',
    agreementName: agreementName,
    id: '104',
    isActive: true,
    sendEmail: false
  },
  {
    fullName: 'Jones, David',
    documentValue: '25-E',
    gender: genderMale,
    generation: generation,
    joinedAt: '18/02/2018',
    agreementName: agreementName,
    id: '105',
    isActive: false,
    sendEmail: true
  },
  {
    fullName: 'Garcia, Maria',
    documentValue: '26-F',
    gender: gender,
    generation: generation,
    joinedAt: '30/05/2018',
    agreementName: agreementName,
    id: '106',
    isActive: true,
    sendEmail: true
  },
  {
    fullName: 'Miller, Robert',
    documentValue: '27-G',
    gender: genderMale,
    generation: generation,
    joinedAt: '14/09/2018',
    agreementName: agreementName,
    id: '107',
    isActive: false,
    sendEmail: false
  },
  {
    fullName: 'Davis, Sarah',
    documentValue: '28-H',
    gender: gender,
    generation: generation,
    joinedAt: '03/01/2019',
    agreementName: agreementName,
    id: '108',
    isActive: true,
    sendEmail: true
  },
  {
    fullName: 'Rodriguez, Carlos',
    documentValue: '29-I',
    gender: genderMale,
    generation: generation,
    joinedAt: '20/04/2019',
    agreementName: agreementName,
    id: '109',
    isActive: false,
    sendEmail: true
  },
  {
    fullName: 'Martinez, Lisa',
    documentValue: '30-J',
    gender: gender,
    generation: generation,
    joinedAt: '12/08/2019',
    agreementName: agreementName2,
    id: '110',
    isActive: true,
    sendEmail: false
  },
  {
    fullName: 'Hernandez, Daniel',
    documentValue: '31-K',
    gender: genderMale,
    generation: generation,
    joinedAt: '25/11/2019',
    agreementName: agreementName2,
    id: '111',
    isActive: true,
    sendEmail: true
  },
  {
    fullName: 'Lopez, Jennifer',
    documentValue: '32-L',
    gender: gender,
    generation: generation,
    joinedAt: '07/03/2020',
    agreementName: agreementName2,
    id: '112',
    isActive: false,
    sendEmail: true
  },
  {
    fullName: 'Gonzalez, James',
    documentValue: '33-M',
    gender: genderMale,
    generation: generation,
    joinedAt: '19/06/2020',
    agreementName: agreementName2,
    id: '113',
    isActive: true,
    sendEmail: false
  },
  {
    fullName: 'Wilson, Patricia',
    documentValue: '34-N',
    gender: gender,
    generation: generation,
    joinedAt: '02/10/2020',
    agreementName: agreementName2,
    id: '114',
    isActive: false,
    sendEmail: true
  },
  {
    fullName: 'Anderson, Thomas',
    documentValue: '35-O',
    gender: genderMale,
    generation: generation,
    joinedAt: '15/01/2021',
    agreementName: agreementName2,
    id: '115',
    isActive: true,
    sendEmail: true
  },
  {
    fullName: 'Taylor, Elizabeth',
    documentValue: '36-P',
    gender: gender,
    generation: generation,
    joinedAt: '28/04/2021',
    agreementName: agreementName2,
    id: '116',
    isActive: true,
    sendEmail: false
  },
  {
    fullName: 'Moore, Christopher',
    documentValue: '37-Q',
    gender: genderMale,
    generation: generation,
    joinedAt: '11/08/2021',
    agreementName: agreementName2,
    id: '117',
    isActive: false,
    sendEmail: true
  },
  {
    fullName: 'Jackson, Margaret',
    documentValue: '38-R',
    gender: gender,
    generation: generation,
    joinedAt: '24/11/2021',
    agreementName: agreementName2,
    id: '118',
    isActive: true,
    sendEmail: true
  },
  {
    fullName: 'Martin, Joseph',
    documentValue: '39-S',
    gender: genderMale,
    generation: generation,
    joinedAt: '09/03/2022',
    agreementName: agreementName2,
    id: '119',
    isActive: false,
    sendEmail: false
  },
  {
    fullName: 'Lee, Barbara',
    documentValue: '40-T',
    gender: gender,
    generation: generation,
    joinedAt: '22/06/2022',
    agreementName: agreementName2,
    id: '120',
    isActive: true,
    sendEmail: true
  }
];
export const MEMBERS_MOCK_DATA: IMembersData[] = [
  {
    fullName: 'Lara, Jorge',
    documentValue: '1-9',
    joinedAt: undefined,
    id: '1',
    hasSendEmail: true,
    status: mockInProgress,
    email: 'jlara@mail.com',
    birthDate: '01/01/1991',
    plans: ['105488'],
    nationalIdentifications: {
      type: 'RUT',
      idValue: '123456789'
    }
  },
  {
    fullName: 'Navarrete, Rodrigo',
    documentValue: '2-7',
    joinedAt: '01/02/1995',
    id: '2',
    hasSendEmail: false,
    status: 'invited',
    email: 'rnavarrete@mail.com',
    birthDate: '01/02/1990',
    plans: ['10'],
    nationalIdentifications: {
      type: 'RUT',
      idValue: '143456789'
    }
  },
  {
    fullName: undefined,
    documentValue: '4-3',
    joinedAt: '01/04/2005',
    id: '4',
    hasSendEmail: false,
    status: mockInProgress,
    email: 'spena2@mail.com',
    birthDate: '01/01/1993',
    plans: ['2'],
    nationalIdentifications: {
      type: 'RUT',
      idValue: '143456789'
    }
  },
  {
    fullName: 'Vidueria, Rodrigo',
    documentValue: undefined,
    joinedAt: undefined,
    id: '5',
    hasSendEmail: false,
    status: mockInProgress,
    email: 'rvidueria@mail.com',
    birthDate: '01/10/1990',
    plans: ['2'],
    nationalIdentifications: {
      type: 'RUT',
      idValue: '153456789'
    }
  },
  {
    fullName: 'Mendoza, Alfred',
    documentValue: '6-K',
    joinedAt: '01/06/2011',
    id: '6',
    hasSendEmail: false,
    status: mockInProgress,
    email: 'amendoza@mail.com',
    birthDate: undefined,
    plans: ['2'],
    nationalIdentifications: {
      type: 'RUT',
      idValue: '163456789'
    }
  },
  {
    fullName: 'Baeza, Luciano',
    documentValue: '7-8',
    joinedAt: '01/07/2012',
    id: '7',
    hasSendEmail: false,
    status: mockInProgress,
    email: 'lbaeza@mail.com',
    birthDate: '09/01/1980',
    plans: ['2'],
    nationalIdentifications: {
      type: 'RUT',
      idValue: '173456789'
    }
  },
  {
    fullName: 'Peña, Sofia',
    documentValue: '8-6',
    joinedAt: '01/08/2013',
    id: '8',
    hasSendEmail: false,
    status: mockInProgress,
    email: 'spena@mail.com',
    birthDate: '01/11/1995',
    plans: ['2'],
    nationalIdentifications: {
      type: 'RUT',
      idValue: '183456789'
    }
  },
  {
    fullName: 'Lacoste, Maria Jose',
    documentValue: '9-4',
    joinedAt: '01/09/2014',
    id: '9',
    hasSendEmail: false,
    status: mockInProgress,
    email: 'mlacoste@mail.com',
    birthDate: '01/03/1994',
    plans: ['2'],
    nationalIdentifications: {
      type: 'RUT',
      idValue: '193456789'
    }
  }
];

export const COLLABORATOR_MOCK_RESPONSE = {
  data: {
    companyId: '20',
    collaborators: [...COLLABORATORS_MOCK_DATA]
  }
};

export const MEMBERS_MOCK_RESPONSE = {
  data: {
    companyId: '20',
    members: [...MEMBERS_MOCK_DATA]
  }
};

export const COLLABORATOR_FILE_MOCK_RESPONSE = {
  data: {
    fileKey: 'InactiveCollaboratorFileMock',
    url: 'https://google.com'
  }
};

export const COMPANY_DATA_MOCK = {
  id: '20',
  name: companyName,
  countryCode: 'es',
  locale: 'es-CL',
  role: {
    name: 'default',
    permissions: ['menu', 'support-form']
  }
};

export const UNSUBSCRIBED_COLLABORATORS_MOCK_DATA: IUnsubscribedCollaboratorsData[] = [
  {
    fullName: 'Lara, Jorge',
    documentValue: '10-9',
    unsubscribedAt: '01/01/1999',
    agreementName: agreementName3,
    id: '1'
  },
  {
    fullName: 'Navarrete, Rodrigo',
    documentValue: '20-7',
    unsubscribedAt: '01/10/1995',
    agreementName: agreementName3,
    id: '2'
  },
  {
    fullName: 'Abusleme, Benjamín',
    documentValue: '30-5',
    unsubscribedAt: '01/03/2000',
    agreementName: agreementName3,
    id: '3'
  },
  {
    fullName: 'Peña, Sofia',
    documentValue: '40-3',
    unsubscribedAt: '01/04/2005',
    agreementName: agreementName3,
    id: '4'
  },
  {
    fullName: 'Vidueria, Rodrigo',
    documentValue: '50-1',
    unsubscribedAt: '01/05/2010',
    agreementName: agreementName3,
    id: '5'
  },
  {
    fullName: 'Mendoza, Alfred',
    documentValue: '60-K',
    unsubscribedAt: '01/06/2011',
    agreementName: agreementName3,
    id: '6'
  },
  {
    fullName: 'Baeza, Luciano',
    documentValue: '70-8',
    unsubscribedAt: '01/07/2012',
    agreementName: agreementName3,
    id: '7'
  },
  {
    fullName: 'Peña, Sofia',
    documentValue: '80-6',
    unsubscribedAt: '01/08/2013',
    agreementName: agreementName3,
    id: '8'
  },
  {
    fullName: 'Lacoste, Maria Jose',
    documentValue: '90-4',
    unsubscribedAt: '01/09/2014',
    agreementName: agreementName3,
    id: '9'
  }
];

export const UNSUBSCRIBED_MEMBERS_MOCK_DATA: IUnsubscribedMembersData[] = [
  {
    email: 'jlara@mail.com',
    plans: ['2'],
    fullName: 'Lara1, Jorge',
    documentValue: '11-9',
    unsubscribedAt: '01/01/1990',
    requesterEmail: requesterEmail
  },
  {
    email: 'rnavarrete@mail.com',
    plans: ['2'],
    fullName: 'Navarrete1, Rodrigo',
    documentValue: '21-7',
    unsubscribedAt: '01/02/1995',
    requesterEmail: requesterEmail
  },
  {
    email: 'babusleme@mail.com',
    plans: ['2'],
    fullName: 'Abusleme1, Benjamín',
    documentValue: '31-5',
    unsubscribedAt: '01/03/2000',
    requesterEmail: requesterEmail
  },
  {
    email: 'spena@mail.com',
    plans: ['2'],
    fullName: 'Peña1, Sofia',
    documentValue: '41-3',
    unsubscribedAt: '01/04/2005',
    requesterEmail: requesterEmail
  },
  {
    email: 'rvidueria@mail.com',
    plans: ['2'],
    fullName: 'Vidueria1, Rodrigo',
    documentValue: '51-1',
    unsubscribedAt: '01/05/2010',
    requesterEmail: requesterEmail
  },
  {
    email: 'amendoza@mail.com',
    plans: ['2'],
    fullName: 'Mendoza1, Alfred',
    documentValue: '61-K',
    unsubscribedAt: '01/06/2011',
    requesterEmail: requesterEmail
  },
  {
    email: 'lbaeza@mail.com',
    plans: ['2'],
    fullName: 'Baeza1, Luciano',
    documentValue: '71-8',
    unsubscribedAt: '01/07/2012',
    requesterEmail: requesterEmail
  },
  {
    email: 'spena1@mail.com',
    plans: ['2'],
    fullName: 'Peña1, Sofia',
    documentValue: '81-6',
    unsubscribedAt: '01/08/2013',
    requesterEmail: requesterEmail
  },
  {
    email: 'mlacoste@mail.com',
    plans: ['2'],
    fullName: 'Lacoste1, Maria Jose',
    documentValue: '91-4',
    unsubscribedAt: '01/09/2014',
    requesterEmail: requesterEmail
  }
];

export const UNSUBSCRIBED_COLLABORATORS_MOCK_RESPONSE = {
  data: {
    companyId: 20,
    collaborators: [...UNSUBSCRIBED_COLLABORATORS_MOCK_DATA]
  }
};

export const UNSUBSCRIBED_MEMBERS_MOCK_RESPONSE = {
  data: {
    companyId: 20,
    members: [...UNSUBSCRIBED_MEMBERS_MOCK_DATA]
  }
};

export const REQUEST_FILE_MOCK_RESPONSE = {
  data: {
    fileKey: 'someName.xlsx',
    url: 'someUrl.cl'
  }
};

export const AVAIABLE_OPPORTUNITIES_MOCK_RESPONSE = {
  data: {
    opportunities: [
      {
        id: '0065d00000wulerAAA',
        name: 'Agile Cell Consulting Group-1'
      },
      {
        id: '0065d00000wulerAAA',
        name: 'Agile Cell Consulting Group-2'
      },
      {
        id: '0065d00000wulerAAA',
        name: 'Agile Cell Consulting Group-3'
      }
    ]
  }
};

export const VALIDATE_PAYROLL_SUCCESS_MOCK_RESPONSE = {
  data: {
    success: true,
    data: [
      {
        lastName: 'Uno',
        secondLastName: 'Apellido',
        firstName: 'Nombre',
        email: 'mail1@gmail.com',
        birthdayDate: '1990-01-01',
        gender: 'M',
        document: {
          value: '12312312-3',
          type: 'RUT',
          countryCode: 'CL'
        },
        contractPlanId: 12
      },
      {
        lastName: 'Dos',
        secondLastName: 'Apellido2',
        firstName: 'Name',
        email: 'mail2@gmail.com',
        birthdayDate: '1990-01-02',
        gender: 'F',
        document: {
          value: '12345678-5',
          type: 'RUT',
          countryCode: 'CL'
        },
        contractPlanId: 12
      }
    ]
  }
};

export const VALIDATE_PAYROLL_ERROR_MOCK_RESPONSE = {
  data: {
    success: false,
    data: [
      {
        docValue: {
          value: '12345657534456',
          error: 'add_collaborator.ne.tooltip.id'
        },
        lastName: {
          value: 'Tres',
          error: ''
        },
        secondLastName: {
          value: 'Apellidos',
          error: ''
        },
        firstName: {
          value: 'Nombre',
          error: ''
        },
        email: {
          value: 'mail@invalido',
          error: 'add_collaborator.ne.tooltip.wrong_email'
        },
        birthdayDate: {
          value: '03-01-1991',
          error: ''
        },
        gender: {
          value: '',
          error: ''
        }
      },
      {
        docValue: {
          value: '19281246-1',
          error: ''
        },
        lastName: {
          value: '',
          error: 'add_collaborator.ne.tooltip.empty'
        },
        secondLastName: {
          value: 'Apellido',
          error: ''
        },
        firstName: {
          value: 'Nombre tan largo que no cabe en la validacion',
          error: 'add_collaborator.ne.tooltip.characters'
        },
        email: {
          value: 'mail3@gmail.com',
          error: ''
        },
        birthdayDate: {
          value: '1992-01-01',
          error: 'add_collaborator.ne.tooltip.date'
        },
        gender: {
          value: '',
          error: ''
        }
      }
    ]
  }
};

export const COLLABORATOR_INSIGHTS_MOCK_RESPONSE = {
  data: {
    actives: 130,
    lastWeekInsight: 25
  }
};

export const COLLABORATOR_BENEFITS_MOCK_RESPONSE = {
  benefits: [
    {
      sku: 'test-sku',
      benefitId: '3',
      title: 'Seguro de vida',
      providerName: 'Chubb',
      icon: 'https://static.techbetterfly.com/benefits/provider/logo_a413fbc9.png',
      category: 'wellbeing',
      subSourceType: 'supplementary',
      status: 'active',
      statusKey: 'status.active',
      isInsurance: false
    },
    {
      sku: 'marketcare',
      benefitId: '4',
      title: 'Salud en línea',
      providerName: 'Conexa',
      icon: 'https://static.techbetterfly.com/benefits/provider/logo_ddbb5d9a.png',
      category: 'health',
      subSourceType: 'complementary',
      status: 'active',
      statusKey: 'status.active',
      isInsurance: false
    },
    {
      sku: 'test-sku',
      benefitId: '760',
      title: 'Entrenamiento físico',
      providerName: 'Hanufit',
      icon: 'https://static.techbetterfly.com/benefits/provider/logo_1252cce9.png',
      category: 'education',
      subSourceType: 'complementary',
      status: 'active',
      statusKey: 'status.active',
      isInsurance: false
    }
  ]
};

export const COLLABORATOR_INVITATION_LINK_MOCK_RESPONSE = {
  data: {
    link: 'https://devbetterflyapp.page.link/?link=https://dev.app.players-auth.betterfly.com/clients-portal/irivera22@gmail.com/2LNnLbsHVRfw&apn=com.betterfly.app.dev&isi=6450281350&ibi=com.betterfly.app.dev&efr=1'
  }
};

export const VALIDATE_COLLABORATORS_MOCK_REPONSE = {
  existingEmails: ['test@betterfly.com'],
  missingEmails: ['test1@betterfly.com']
};

export const MOCK_COLLABORATOR: IMembersData = {
  id: '1',
  email: 'john.doe@example.com',
  fullName: 'John Doe',
  documentValue: '123456789',
  birthDate: '1990-05-15',
  status: 'active',
  joinedAt: '2023-01-10',
  lastInvitationSentAt: '2023-02-15',
  photo: 'https://example.com/photos/john.jpg',
  hasSendEmail: true,
  nationalIdentifications: {
    type: 'passport',
    idValue: 'A12345678'
  },
  plans: ['basic', 'premium']
};

export const MOCK_COLLABORATOR_DEPENDENTS: ICollaboratorDependents = {
  dependents: [
    {
      id: '1025f1e3-1591-4804-882d-27845330d4ad',
      name: 'Ana Gómez García',
      email: 'test2@betterfly.com',
      relationship: 'partner',
      birthDate: '2020-01-01',
      docValue: '17.032.667-7',
      docType: 'rut',
      benefits: [
        {
          id: '7eeb21ac-acef-4416-b644-ff7539233894',
          title: 'Seguro de vida',
          sku: 'chubb-life-CL-migration',
          providerName: 'Chubb',
          status: 'pending_dps',
          statusKey: 'status.pending_document',
          startDate: null
        },
        {
          id: '9c106d8b-059e-47bf-98d9-ed1e3e16c8ec',
          title: 'Protege tu salud',
          sku: 'chubb-health-CL-start',
          providerName: 'Chubb',
          status: 'active',
          statusKey: '',
          startDate: '2025-07-15T16:00:00.624000+00:00'
        }
      ]
    },
    {
      id: '3ad91d34-0560-4148-b75c-921dbc40be90',
      name: 'Pedro Ramírez Lopez',
      email: 'test3@betterfly.com',
      relationship: 'child',
      birthDate: '2020-01-01',
      docValue: '25.032.667-3',
      docType: 'rut',
      benefits: [
        {
          id: 'fb6a0567-2aba-4d23-a271-2b3d1973d172',
          title: 'Seguro de vida',
          sku: 'chubb-life-CL-migration',
          providerName: 'Chubb',
          status: 'rejected_by_company',
          statusKey: '',
          startDate: null
        }
      ]
    }
  ]
};

export const MOCK_COLLABORATORS_WITH_ERRORS: IMemberByFileData[] = [
  {
    docType: {
      value: 'RUT',
      error: ''
    },
    docValue: {
      value: '14232983-1',
      error: 'El documento de identidad del colaborador no es v\u00e1lido'
    },
    lastName: {
      value: '',
      error: 'Campo vac\u00edo'
    },
    secondLastName: {
      value: 'Chitest',
      error: ''
    },
    firstName: {
      value: 'Maria Lucia]',
      error: 'Campo contiene uno o m\u00e1s caracteres inv\u00e1lidos'
    },
    email: {
      value: 'MARIA@CHITEST.COM',
      error: ''
    },
    birthdayDate: {
      value: '24-01-1995',
      error: ''
    },
    gender: {
      value: '',
      error: 'Campo vac\u00edo'
    }
  }
];

export const MOCK_COLLABORATORS_WITHOUT_ERRORS: IMemberByFileData[] = [
  {
    docType: {
      value: 'CC',
      error: ''
    },
    docValue: {
      value: '1111111',
      error: ''
    },
    lastName: {
      value: 'Perez',
      error: ''
    },
    secondLastName: {
      value: 'Gonalves',
      error: ''
    },
    firstName: {
      value: 'Jose camilo',
      error: ''
    },
    email: {
      value: 'btf@gmail.com',
      error: ''
    },
    birthdayDate: {
      value: '24-01-1995',
      error: ''
    },
    gender: {
      value: 'M',
      error: ''
    }
  }
];

export const MOCK_COLLABORATOR_DETAILS_RF_DATA: ICollaboratorDataRF = {
  hasNovation: false,
  salary: 10230,
  hoursPerWeek: 45,
  zipCode: '12345'
};

export const MOCK_MEMBER_FR_CYCLE_CONSUMPTIONS: IMemberFRCycleConsumptions = {
  payrollId: '2696bdf0-39d9-438b-99fb-a9f4eefc8658',
  cycleYear: 2026,
  cycleMonth: 7,
  currency: 'EUR',
  hasData: true,
  consumptions: [
    { sku: 'flexible-remuneration-meal', exempt: 120, nonExempt: 30, total: 150 },
    { sku: 'flexible-remuneration-transport', exempt: 40, nonExempt: 0, total: 40 }
  ],
  total: 190,
  totalExempt: 160,
  totalNonExempt: 30
};

export const MOCK_MEMBER_FR_CARD_BALANCES: IMemberFRCardBalances = {
  currency: 'EUR',
  balances: [
    { sku: 'flexible-remuneration-meal', balance: 245.75 },
    { sku: 'flexible-remuneration-transport', balance: 80 }
  ],
  total: 325.75
};

export const MOCK_COLLABORATOR_INSURANCE_DETAIL: ICollaboratorInsuranceDetail = {
  startDate: '29-04-2025',
  endDate: '31-12-2099',
  generalStatus: 'process_acceptance',
  activationDate: null
};

export const MOCK_DOWNLOAD_EXTERNAL_FILE_RESPONSE: IExternalFileResponse = {
  url: '/download/file.xlsx'
};

export const MOCK_DEPENDENTS_BY_FILE_VALIDATION: IValidateDependentsFileResponse = {
  success: true,
  requestId: 'requestId',
  data: [
    {
      benefits: [
        {
          sku: 'chubb-health-CL-gastosmedicosbo'
        }
      ],
      contractPlanId: 106732,
      ownerDocument: {
        value: '1441313-8',
        type: 'RUT'
      },
      dependants: [
        {
          birthdayDate: '1984-10-14',
          countryCode: 'CL',
          document: {
            value: '12650464-0',
            type: 'RUT'
          },
          gender: 'F',
          lastName: 'Molinero',
          name: 'Luz',
          relation: 'partner',
          secondLastName: 'Hervas'
        },
        {
          birthdayDate: '2001-01-13',
          countryCode: 'CL',
          document: {
            value: '24009606-4',
            type: 'RUT'
          },
          gender: 'M',
          lastName: 'Lopez',
          name: 'Gustavo',
          relation: 'child',
          secondLastName: 'Zamorano'
        },
        {
          birthdayDate: '2003-06-04',
          countryCode: 'CL',
          document: {
            value: '28452323-7',
            type: 'RUT'
          },
          gender: 'F',
          lastName: 'Manzanares',
          name: 'Judith',
          relation: 'child',
          secondLastName: 'Segura'
        },
        {
          birthdayDate: '2000-11-05',
          countryCode: 'CL',
          document: {
            value: '21973166-3',
            type: 'RUT'
          },
          gender: 'M',
          lastName: 'Valenzuela',
          name: 'Jose Fernando',
          relation: 'child',
          secondLastName: 'Cazorla'
        }
      ]
    }
  ]
};

export const MOCK_DEPENDENTS_BY_FILE_VALIDATION_WITH_ERRORS: IValidateDependentsFileResponse = {
  success: false,
  requestId: null,
  data: {
    invalids: [
      {
        memberDocValue: {
          value: '9271723-2',
          error: 'El plan del colaborador no \nadmite familiares'
        },
        dependentDocValue: {
          value: '12650464-0',
          error: ''
        },
        lastName: {
          value: 'Molinero',
          error: ''
        },
        secondLastName: {
          value: 'Hervas#',
          error: 'Uno o más caracteres ingresados son inválidos'
        },
        firstName: {
          value: 'Luz',
          error: ''
        },
        relationship: {
          value: 'Esposa',
          error: 'El parentesco debe ser \nHijo o Cónyugue'
        },
        birthdayDate: {
          value: '14-10',
          error: 'La fecha debe ser en formato DD-MM-AAAA'
        },
        gender: {
          value: 'F',
          error: ''
        }
      },
      {
        memberDocValue: {
          value: '1441313-8',
          error: ''
        },
        dependentDocValue: {
          value: '24009606-4',
          error: 'Este documento ya se encuentra en este archivo'
        },
        lastName: {
          value: '',
          error: 'Debes completar este campo'
        },
        secondLastName: {
          value: '',
          error: ''
        },
        firstName: {
          value: '',
          error: 'Debes completar este campo'
        },
        relationship: {
          value: 'Hijo',
          error: ''
        },
        birthdayDate: {
          value: '04-06-2033',
          error: 'Verifica que la fecha ingresada\nsea correcta'
        },
        gender: {
          value: 'M',
          error: ''
        }
      },
      {
        memberDocValue: {
          value: '',
          error: 'Debes completar este campo'
        },
        dependentDocValue: {
          value: '28452323-6',
          error: 'El documento de identidad no es válido'
        },
        lastName: {
          value: 'ManzanaresManzanaresManzanaresManzanares',
          error: 'El texto debe tener menos de 30 caracteres'
        },
        secondLastName: {
          value: 'Segura',
          error: ''
        },
        firstName: {
          value: 'Judith',
          error: ''
        },
        relationship: {
          value: 'Hijx',
          error: 'El parentesco debe ser \nHijo o Cónyugue'
        },
        birthdayDate: {
          value: '04-06-2003',
          error: ''
        },
        gender: {
          value: 'O',
          error: ''
        }
      },
      {
        memberDocValue: {
          value: '1441313-8',
          error: ''
        },
        dependentDocValue: {
          value: '',
          error: 'Debes completar este campo'
        },
        lastName: {
          value: 'Valenzuela',
          error: ''
        },
        secondLastName: {
          value: 'Cazorla',
          error: ''
        },
        firstName: {
          value: 'Jose Fernando',
          error: ''
        },
        relationship: {
          value: 'Hijo/a',
          error: ''
        },
        birthdayDate: {
          value: '05-11-1980',
          error: 'La fecha ingresada excede la \nedad permitida '
        },
        gender: {
          value: 'M',
          error: ''
        }
      },
      {
        memberDocValue: {
          value: '9271723-2',
          error: 'El plan del colaborador no \nadmite familiares'
        },
        dependentDocValue: {
          value: '24314228-8',
          error: ''
        },
        lastName: {
          value: 'Hurtado',
          error: ''
        },
        secondLastName: {
          value: '',
          error: ''
        },
        firstName: {
          value: 'Marina',
          error: ''
        },
        relationship: {
          value: '',
          error: 'Debes completar este campo'
        },
        birthdayDate: {
          value: '',
          error: 'Debes completar este campo'
        },
        gender: {
          value: 'L',
          error: 'Debes ingresar el género como F, M u O'
        }
      },
      {
        memberDocValue: {
          value: '10565803-6',
          error: 'Este documento no corresponde a un\ncolaborador añadido a Betterfly'
        },
        dependentDocValue: {
          value: '28059672-8',
          error: ''
        },
        lastName: {
          value: '',
          error: 'Debes completar este campo'
        },
        secondLastName: {
          value: 'Calle',
          error: ''
        },
        firstName: {
          value: 'Leticia',
          error: ''
        },
        relationship: {
          value: 'Conyuge',
          error: ''
        },
        birthdayDate: {
          value: '20-10-2010',
          error: 'El cónyugue debe ser mayor \nde 18 años'
        },
        gender: {
          value: '',
          error: 'Debes completar este campo'
        }
      }
    ],
    valids: [
      {
        memberDocValue: '1441313-8',
        dependentDocValue: '24009606-4',
        lastName: 'Lopez',
        secondLastName: 'Zamorano',
        firstName: 'Gustavo',
        relationship: 'Hijo/a',
        birthdayDate: '13-01-2001',
        gender: 'M'
      }
    ]
  }
};

export const MOCK_DEPENDENTS_WITHOUT_ERRORS = [
  {
    memberDocValue: {
      value: '9271723-2',
      error: ''
    },
    dependentDocValue: {
      value: '12650464-0',
      error: ''
    },
    lastName: {
      value: 'Molinero',
      error: ''
    },
    secondLastName: {
      value: 'Hervas#',
      error: ''
    },
    firstName: {
      value: 'Luz',
      error: ''
    },
    relationship: {
      value: 'Esposa',
      error: ''
    },
    birthdayDate: {
      value: '14-10',
      error: ''
    },
    gender: {
      value: 'F',
      error: ''
    }
  }
];

export const MOCK_INSURANCE_CERTIFICATES = [
  {
    type: 'GMM',
    url: 'https://example.com/certificates/gmm_certificate.pdf'
  },
  {
    type: 'VIDA',
    url: 'https://example.com/certificates/vida_certificate.pdf'
  },
  {
    type: 'AP',
    url: 'https://example.com/certificates/ap_certificate.pdf'
  }
];
